import { Port } from '@navstation-portal/ports/data-model/ports';
import { SelectOption } from '@navstation-portal/shared/data-model/common';

function createSelectOption(port: Port): SelectOption {
  return {
    name: `${port.name}${port.country ? ` (${port.country})` : ''}`,
    code: port.code,
  };
}

export function portsToSelectOptions(ports: Port[]): SelectOption[] {
  if (!ports?.length) return [];

  return ports.map((port) => createSelectOption(port));
}

export function portCodeToSelectOption(code?: string, ports?: Port[]): SelectOption | undefined {
  if (!code || !ports?.length) return;

  const port = ports.find((port) => port.code.toLocaleLowerCase() === code.toLocaleLowerCase());
  if (!port) return;

  return createSelectOption(port);
}
